import React from 'react';
import { Button } from 'react-bootstrap';
import OrderItems from './OrterItems';
import { states as orderStates, highlightStates, COMPLEATED, defaultHighlightColor } from '../../constants/orderStates';
import { formatPhone } from '../../extensions/phoneHelper';
import { formatDateTime, formatDateTimePeriod } from '../../extensions/dateHelper';


let OrderRow = class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rowExpanded: false
        };
        this._onToggle = this._onToggle.bind(this);
    }

    _onToggle(e) {
        e.preventDefault();
        this.setState({ rowExpanded: !this.state.rowExpanded });
    }

    render() {
        const { order, onEditClick, delivery, isReport } = this.props;
        const { rowExpanded } = this.state;
        const state = orderStates.find(cs => cs.Id === order.State).Name;
        const highlight = highlightStates.some(a => a === order.State) || (order.HighlightColor != null && order.HighlightColor !== defaultHighlightColor) ? order.HighlightColor : undefined;
        const isEditAvailable = order.State != COMPLEATED;
        return (
            <tbody style={{ background: highlight }}>
                <tr>
                    <td><Button onClick={this._onToggle}>{rowExpanded ? '-' : '+'}</Button></td>
                    <td>{order.Id}</td>
                    <td>{formatDateTime(order.CreatedAt)}</td>
                    <td>{formatPhone(order.Phone)}</td>
                    <td>{state}</td>
                    <td>{order.PickupAddressString}</td>
                    <td>{formatDateTimePeriod(order.PickupDate, order.IsPickupNow, true)}</td>
                    <td>{formatDateTimePeriod(order.OffloadDate, false, true)}</td>
                    <td>
                        {isReport ?
                            <div>
                                <div>Стоимость: {order.Total.TotalAmount}</div>
                                <div>Доставка: {order.Total.DeliveryAmount}</div>
                            </div> :
                            <Button disabled={!isEditAvailable} onClick={() => onEditClick(order)}>Редактировать</Button>
                        }</td>
                </tr>
                {rowExpanded && <tr>
                    <td colSpan='8'>
                        <OrderItems orderId={order.Id} delivery={delivery} discount={order.Discount} isReport={isReport} />
                    </td>
                </tr>}
            </tbody>);
    }
}

OrderRow.defaultProps = {
    isReport: false
};

export default OrderRow;


// WEBPACK FOOTER //
// ./src/components/orders/OrderRow.jsx